import { appendLiteralFieldTrimPagedFilter } from './tabulatorProgressiveLoading';
import { WORKFLOW_NEXT_STEP_PHASES } from './workflowNextStepLabel';

export const CRM_COMM_NEXT_STEP_FIELD = 'workflow_next_step_label';
export const CRM_COMM_NEXT_STEP_LEGACY_FIELD = 'execution_crm_step_id';

export function parseCrmHeaderMulti(headerValue) {
  if (headerValue == null || headerValue === '') return [];
  if (Array.isArray(headerValue)) {
    return headerValue.map((x) => String(x ?? '').trim()).filter(Boolean);
  }
  if (typeof headerValue === 'object' && Array.isArray(headerValue?.value)) {
    return headerValue.value.map((x) => String(x ?? '').trim()).filter(Boolean);
  }
  return String(headerValue).split(/[\s,;|]+/).map((x) => x.trim()).filter(Boolean);
}

export function normalizeCrmTicketSorterField(field) {
  return field === CRM_COMM_NEXT_STEP_LEGACY_FIELD ? CRM_COMM_NEXT_STEP_FIELD : field;
}

export function normalizeCrmTicketSorters(sorters) {
  if (!Array.isArray(sorters)) return [];
  return sorters
    .map((sorter) => {
      const field = normalizeCrmTicketSorterField(sorter?.field ?? sorter?.column);
      if (typeof field !== 'string' || field.trim() === '') return null;
      const dir = sorter?.dir === 'desc' ? 'desc' : 'asc';
      return { field, dir };
    })
    .filter(Boolean);
}

function appendNextStepFilter(value, extra) {
  const parts = parseCrmHeaderMulti(value);
  if (parts.length === 0) return;
  const phases = parts.filter((part) => WORKFLOW_NEXT_STEP_PHASES.includes(part));
  if (phases.length > 0 && phases.length === parts.length) {
    extra.filter_workflow_next_step_phase = phases.join(',');
    return;
  }
  extra.filter_execution_crm_step_label = parts.join(' ');
}

export function appendCrmCommunicationTicketFilter(f, extra) {
  if (f?.field === 'status_indicator' || f?.field === 'semaphore_a_color') {
    const v = f.value;
    if (v === undefined || v === null || String(v).trim() === '') return;
    extra.filter_status_indicator = String(v).trim();
    return;
  }
  if (f?.field === 'is_unread') {
    const parts = parseCrmHeaderMulti(f.value).map((x) => String(x).toLowerCase());
    if (parts.length === 1) {
      if (parts[0] === 'true' || parts[0] === '1') extra.filter_is_unread = '1';
      else if (parts[0] === 'false' || parts[0] === '0') extra.filter_is_unread = '0';
    }
    return;
  }
  if (f?.field === 'type') {
    const parts = parseCrmHeaderMulti(f.value);
    if (parts.length > 0) extra.filter_type = parts.join(',');
    return;
  }
  if (f?.field === 'status_id') {
    const ids = parseCrmHeaderMulti(f.value);
    if (ids.length > 0) extra.filter_status_id = ids.join(',');
    return;
  }
  if (f?.field === 'workflow_state_label') {
    const v = f.value;
    if (v === undefined || v === null || String(v).trim() === '') return;
    extra.filter_status = String(v).trim();
    return;
  }
  if (f?.field === CRM_COMM_NEXT_STEP_FIELD) {
    appendNextStepFilter(f.value, extra);
    return;
  }
  if (f?.field === CRM_COMM_NEXT_STEP_LEGACY_FIELD) {
    const parts = parseCrmHeaderMulti(f.value);
    if (parts.length === 0) return;
    if (parts.every((part) => WORKFLOW_NEXT_STEP_PHASES.includes(part))) {
      extra.filter_workflow_next_step_phase = parts.join(',');
      return;
    }
    const raw = parts.join(',');
    if (/^\d+(,\d+)*$/.test(raw.replace(/\s/g, ''))) {
      extra.filter_execution_crm_step_id = raw;
    } else {
      extra.filter_execution_crm_step_label = parts.join(' ');
    }
    return;
  }
  if (f?.field === 'execution_crm_step_label') {
    const v = f.value;
    if (v === undefined || v === null || String(v).trim() === '') return;
    extra.filter_execution_crm_step_label = String(v).trim();
    return;
  }
  appendLiteralFieldTrimPagedFilter(f, extra);
}
